import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Tempo para a tela nova montar e trazer o título (algumas buscam dados antes).
export const ATRASO_ANUNCIO_MS = 700;

// Título da tela atual: o <h1> do miolo; sem ele, o título da aba.
export const tituloDaTela = (doc = document) => {
  const titulo = doc.querySelector('#conteudo-principal h1');
  return ((titulo && titulo.textContent) || doc.title || '').replace(/\s+/g, ' ').trim();
};

// Numa SPA o leitor de tela não percebe a troca de página: o foco fica no link
// do menu e nada é lido. Este anunciador (só para leitor de tela, sem efeito
// visual) diz "Página carregada: <título>" a cada troca de rota. Não anuncia a
// primeira carga (o leitor já lê a página) nem trocas só de ?query (cada tela
// cuida das próprias mudanças internas).
const AnunciadorDeRota = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation('common');
  const [mensagem, setMensagem] = useState('');
  // Rota já anunciada (ou a da primeira carga). Comparar o caminho, e não
  // contar execuções, mantém o silêncio também no StrictMode (efeito em dobro).
  const rotaAnterior = useRef(pathname);
  const tRef = useRef(t);
  tRef.current = t;

  useEffect(() => {
    if (rotaAnterior.current === pathname) return undefined;
    rotaAnterior.current = pathname;
    setMensagem('');
    const id = window.setTimeout(() => {
      const titulo = tituloDaTela();
      if (titulo) setMensagem(tRef.current('a11y.pageLoaded', { title: titulo }));
    }, ATRASO_ANUNCIO_MS);
    return () => window.clearTimeout(id);
  }, [pathname]);

  return (
    <div className="sr-only" role="status" aria-live="polite" aria-atomic="true" data-testid="anunciador-de-rota">
      {mensagem}
    </div>
  );
};

export default AnunciadorDeRota;
